import { customAlphabet } from "nanoid";

export const ALPHABET = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const generateId = () => {
  const nanoid = customAlphabet(ALPHABET, 20);
  return nanoid();
};
